import { Box, Divider } from '@wix/design-system';
import React from 'react';
import { Collapse, ToggleCollapsibleButton, useCollapse, } from '../../../Collapse';
export const MobileProductCardFeatureList = ({ children, isOpen: isOpenDefault = false, onToggle, labels }) => {
    const { isOpen, toggleCollapse } = useCollapse({ isOpen: isOpenDefault });
    const handleClick = () => {
        onToggle?.(isOpen ? 'close' : 'open');
        toggleCollapse();
    };
    return (React.createElement(Box, { direction: "vertical", gap: "SP3", marginBottom: "SP3", marginTop: "SP3" },
        React.createElement(Collapse, { isOpened: isOpen },
            React.createElement(Box, { direction: "vertical", gap: "SP2" }, children)),
        React.createElement(Divider, null),
        React.createElement("div", { onClick: handleClick },
            React.createElement(ToggleCollapsibleButton, { labels: labels, isOpen: isOpen, skin: "dark", visible: true }))));
};
//# sourceMappingURL=MobileProductCardFeatureList.js.map